
import VideoCardPlaylist from '../../../../components/VideoCardPlaylist';
import ReorderPlaylistComponent from '../../../../components/Playlist/ReorderPlaylistComponent';
import useScreenWidth from '../../../../../hook/useScreenWidth';
import { Playlist } from '../../../../../constants/Playlist';

const PlaylistContent = ({
	videos,
	playlist,
	wishListArr,
	savedVideos,
	handleWishList,
	handleSaveUnsave,
	handleDeleteVideo,
	subscriptionStatus,
	onReorder,
	isReordering = false, 
}) => {
	const { width } = useScreenWidth();
	const allVideos = Array.isArray(videos) && videos.length > 0 ? videos : [];
	const displayVideos = allVideos;
	

	return (
		<div className="p-0">
		  {isReordering ? (
			<ReorderPlaylistComponent
			  items={displayVideos.map((video, i) => ({ ...video, id: video._id, position: i }))}
			  onReorder={(next, updates) => onReorder(next, updates)}
			  
			  
			  renderItem={(video) => (
				<div className="mb-2">
				  <VideoCardPlaylist
					video={video}
					playlistId={playlist?._id}
					isLiked={savedVideos.includes(video._id)}
					viewType={playlist?.type}
					fld={playlist}
					savedVideos={savedVideos}
					showAddToPlaylist={false}
					handleSaveUnsave={handleSaveUnsave}
					subscriptionStatus={subscriptionStatus}
					handleDeleteVideo={handleDeleteVideo}
					isReordering={isReordering}
				  />
				</div>
			  )}
			  gap={8}
			  
			/>
		  ) : (
			<div className="c-video_list-playlist">
			  {displayVideos.map((video, index) => (
				<div key={`${video._id}-${index}`} className="mb-2">
				  <VideoCardPlaylist
					video={video}
					playlistId={playlist?._id}
					isLiked={savedVideos.includes(video._id)}
					viewType={playlist?.type}
					fld={playlist}
					savedVideos={savedVideos}
					showAddToPlaylist={false}
					handleSaveUnsave={handleSaveUnsave}
					subscriptionStatus={subscriptionStatus}
					handleDeleteVideo={handleDeleteVideo}
				  />
				</div>
			  ))}
			</div>
		  )}
		</div>
	  );
};

export default PlaylistContent;
